import { MapPrivacyLevel } from '~/_shared/types/map';
import { useMapInfoPrivacySelector } from '~/store/mapInfo/mapInfo.selectors';
import { useIsMapPresentationalSelector } from '~/store/selectors/useMapInfoSelectors';

export const useIsDriveTimePolygonToolEnabled = () => {
  const isMapPresentational = useIsMapPresentationalSelector();
  const mapPrivacy = useMapInfoPrivacySelector();

  if (!isMapPresentational) {
    return true;
  }

  return mapPrivacy?.mapPrivacyLevel === MapPrivacyLevel.PasswordProtected;
};
